// Kitchen-facing presentation only. Values sent to the API remain untouched.
export const formatProductionQuantity = value => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "—";
  return String(Number(numeric.toFixed(1)));
};

export const formatProductionAmount = (value, unit) => `${formatProductionQuantity(value)}${unit ? ` ${unit}` : ""}`;
